class LogoGrid {
  constructor() {
    this.classes = this.sectionClasses;
    this.selectors = this.sectionSelectors;
    this.debug = false;
  }

  get sectionClasses() {
    return {
      section: 'js-lsg-logo-grid',
      logosSlider: 'js-logo-grid-logos-slider',
      logosContent: 'js-logo-grid-logos-content',
      logoGridSliderWrapper: 'js-logo-grid-logos-slider-wrapper',
    };
  }

  get sectionSelectors() {
    return {
      sections: document.querySelectorAll(`.${this.sectionClasses.section}`),
    };
  }

  init() {
    if (this.debug) {
      console.log('LogoGrid: Initializing...');
      console.log('LogoGrid: Found sections:', this.selectors.sections.length);
    }
    this.setupSliders();
  }

  setupSliders() {
    this.selectors.sections.forEach((section, index) => {
      const logosContent = section.querySelector(`.${this.classes.logosContent}`);
      const logosSlider = section.querySelector(`.${this.classes.logosSlider}`);
      const sliderWrapper = section.querySelector(`.${this.classes.logoGridSliderWrapper}`);

      if (this.debug) {
        console.log(`LogoGrid: Section ${index}:`, {
          hasContent: !!logosContent,
          hasSlider: !!logosSlider,
          hasWrapper: !!sliderWrapper,
          contentWidth: logosContent?.offsetWidth,
          sliderWidth: logosSlider?.offsetWidth,
          wrapperWidth: sliderWrapper?.offsetWidth,
        });
      }

      if (logosContent && logosSlider && sliderWrapper) {
        if (this.debug) {
          console.log(`LogoGrid: All elements found for section ${index}, creating slider...`);
        }
        this.createInfiniteSlider(logosContent, sliderWrapper);
      } else {
        if (this.debug) {
          console.log(`LogoGrid: Missing elements for section ${index}:`, {
            content: !!logosContent,
            slider: !!logosSlider,
            wrapper: !!sliderWrapper,
          });
        }
      }
    });
  }

  createInfiniteSlider(contentElement, sliderWrapper) {
    if (this.debug) {
      console.log('LogoGrid: Creating infinite slider...');
      console.log('LogoGrid: Original content width:', contentElement.offsetWidth);
    }

    // Hide the original content
    contentElement.classList.add('hidden');

    // Clone the content multiple times for smooth infinite loop
    const clones = [];
    const numberOfClones = 4; // Clone 4 times for better infinite loop

    for (let i = 0; i < numberOfClones; i++) {
      const clone = contentElement.cloneNode(true);
      clone.classList.remove('hidden');
      clone.classList.add('logo-clone');
      clones.push(clone);
    }

    if (this.debug) {
      console.log('LogoGrid: Created', clones.length, 'clones');
    }

    // Add clones to existing wrapper
    clones.forEach((clone, index) => {
      sliderWrapper.appendChild(clone);
      if (this.debug) {
        console.log(`LogoGrid: Added clone ${index + 1}, width:`, clone.offsetWidth);
      }
    });

    if (this.debug) {
      console.log('LogoGrid: Wrapper width after adding clones:', sliderWrapper.offsetWidth);
    }

    // Add animation to the wrapper
    this.addSliderAnimation(sliderWrapper, contentElement);
  }

  addSliderAnimation(sliderWrapper, originalContent) {
    const animationDuration = 20000; // 20 seconds for one complete cycle

    // Get the width of one clone (which should be the same as original content)
    const firstClone = sliderWrapper.querySelector('.logo-clone');
    const contentWidth = firstClone ? firstClone.offsetWidth : originalContent.offsetWidth;

    if (this.debug) {
      console.log('LogoGrid: Animation setup:', {
        contentWidth,
        animationDuration,
        wrapperWidth: sliderWrapper.offsetWidth,
        totalClones: sliderWrapper.querySelectorAll('.logo-clone').length,
      });
    }

    if (contentWidth <= 0) {
      console.error('LogoGrid: Content width is 0 or negative, cannot animate');
      return;
    }

    // Create keyframes for infinite scroll
    const keyframes = [
      { transform: 'translateX(0)' },
      { transform: `translateX(-${contentWidth}px)` },
    ];

    const animationOptions = {
      duration: animationDuration,
      iterations: Infinity,
      easing: 'linear',
    };

    // Apply animation to the wrapper
    const animation = sliderWrapper.animate(keyframes, animationOptions);

    if (this.debug) {
      console.log('LogoGrid: Animation created:', animation);
    }

    // Store animation reference for potential future control
    sliderWrapper.animation = animation;
  }
}

export default LogoGrid;
